export const Content = {
	benefits: [
		{
			title: 'Autonomía para correr hasta 298km',
			icon: 'charge',
			text: 'Autonomía suficiente para los que corren por la ciudad y no necesitan preocuparse de cargar más de 1 vez a la semana.',
			showText: false,
		},
		{
			title: 'Carga en toma de casa',
			icon: 'tomada',
			text: 'Puedes recargar tu coche desde el enchufe de tu casa, al igual que recargas tu móvil.',
			showText: false,
		},
		{
			title: 'Mayor economia',
			icon: 'economia',
			text: 'El Kwid E-TECH 100% eléctrico ofrece un mayor ahorro. Con la mejor eficiencia energética por km recorrido del mercado, puede llegar a ser 8 veces más económico que los coches de combustión. Además de tener menos elementos mecánicos con menores costos de mantenimiento.',
			showText: false,
		},
		{
			title: 'Más comodidad y mejor manejo',
			icon: 'love-car',
			text: 'El Kwid E-TECH 100% eléctrico es cómodo, cero ruido, sin vibraciones y sin cambios de marcha: es más placer de conducir.',
			showText: false,
		},
		{
			title: 'Más de 2000 puntos de recarga',
			icon: 'bateria',
			text: 'Más de 2.000 puntos de recarga repartidos por todo Brasil en centros comerciales, tiendas, mercados y concesionarios Renault.',
			showText: false,
		},
		{
			title: 'Cero emisiones de CO₂ a la atmósfera',
			icon: 'planet',
			text: 'El Kwid e-tech 100% eléctrico tiene cero emisiones de CO₂, cero ruido, energía limpia al cargar y la batería es reciclada por Renault al final de su vida.',
			showText: false,
		},
	],
	porqueAssinar: [
		{
			name: 'vantagens',
			items: [
				{
					img: 'return-car.svg',
					title: 'Práctico',
					text: '¡Configura tu suscripción y déjanos la preocupación de la documentación, el registro y el mantenimiento!',
				},
				{
					img: 'check-car.svg',
					title: 'Tranquilo',
					text: 'Revisiones por nuestra cuenta y servicio 24 horas para solucionar cualquier urgencia.',
				},
				{
					img: 'cashback.svg',
					title: 'Económico',
					text: 'Cero coche y sin costes de compra. E incluso personalizas el importe del primer pago y de las próximas mensualidades.',
				},
				{
					img: 'hands.svg',
					title: 'Transparente',
					text: 'Sin costes ocultos ni trampas. Hemos reunido todo lo que necesitas en la suscripción.',
				},
			],
		},
		{
			name: 'incluso',
			items: [
				{
					img: 'doc-taxas.svg',
					title: 'Documentación y Tarifas',
					text: 'Su automóvil está completamente registrado y listo para conducir desde el primer día.',
				},
				{
					img: 'seguro-auto.svg',
					title: 'Seguro de automóvil y cobertura de ventana',
					text: 'Tenga la seguridad de que usted y su automóvil están protegidos contra robos, robos, incendios y colisiones. Asistencia para lunas, faros y luces traseras del vehículo con franquicia reducida.',
				},
				{
					img: 'seguro-terceiros.svg',
					title: 'Seguro de tercero',
					text: 'Estás protegido contra los daños materiales y corporales causados ​​a terceros. Franquicia gratis.',
				},
				{
					img: 'revisoes.svg',
					title: 'Revisiones preventivas',
					text: 'Todos los costos de mantenimiento preventivo están cubiertos en su suscripción.',
				},
				{
					img: 'assistencia.svg',
					title: 'Asistencia 24 horas',
					text: 'Cuente con grúa, cerrajería, carga de batería, cambio de llantas, entre otros, en cualquier momento y en cualquier lugar.',
				},
				{
					img: 'Condutores.svg',
					title: 'conductores ilimitados',
					text: 'Puedes compartir el coche con otras personas sin coste adicional.',
				},
			],
		},
		{
			name: 'assinar',
			items: [
				{
					img: 'cnh.svg',
					title: 'possuir cnh',
					text: 'Para assinar o Renault Renting você precisa ter 21 anos ou mais, CPF válido e possuir CNH compatível com o veículo escolhido, com um mínimo de 3 anos da primeira emissão.',
				},
				{
					img: 'credito.svg',
					title: 'Pagar a pré-reserva',
					text: 'Tudo que você precisa fazer é realizar o pagamento e aguardar a aprovação. Após ter a sua pré-reserva aprovada, você já estará na fila de espera para o lançamento do Kwid E-tech.',
				},
				{
					img: 'assinar.svg',
					title: 'assinar o contrato',
					text: 'Com tudo aprovado, nós emitimos o contrato para assinatura online e logo após você efetua o pagamento do valor de entrada para garantir seu Renault 0Km.',
				},
				{
					img: 'aproveitar.svg',
					title: 'aproveitar',
					text: 'Agora é só esperar. Em alguns dias você terá seu Renault 0Km na garagem para aproveitar a vida no seu tempo, do seu jeito.',
				},
			],
		},
	],
	perguntasFaq: [
		{
			id: 0,
			question: 'Como funciona a assinatura pelo Renault Renting?\n',
			answer:
				'Com a assinatura de veículo Renault Renting, você escolhe o carro que mais combina com o seu estilo de vida, o período e a quilometragem que melhor se encaixam nos seus hábitos e sai por aí de carro novinho, por um valor fixo mensal. Você aproveita todas as vantagens de ter um Renault 0km sem se preocupar com documentação, IPVA, licenciamento, seguro, revisões, revenda do veículo, depreciação etc. Está tudo incluso na sua assinatura Renault Renting.',
		},
		{
			id: 1,
			question: 'Como funciona pré-reserva do Kwid E-tech com a Renault Renting?',
			answer:
				'Através da pré-reserva, você poderá ser um(a) dos(as) primeiros(as) brasileiros(as) a ter a chance de dirigir um Kwid E-tech. Basta escolher o plano e a quilometragem que mais se encaixam no seu estilo de vida através da simulação e  realizar seu pagamento. Após ter a sua pré-reserva aprovada, você já estará na fila de espera para o lançamento do Kwid E-tech. Ah, e pode ficar tranquilo, caso a sua pré-reserva não seja aprovada, nós devolveremos o seu dinheiro, sem dor de cabeça. =)',
		},
		{
			id: 2,
			question: 'Como funciona o carregamento do Kwid E-tech?',
			answer:
				'Carregar seu Kwid E-Tech é simples e pode ser feito até em casa. Tudo o que ele precisa é de uma tomada 220v, um carregador adaptador ou uma wallbox. Em uma noite, seu elétrico recarrega 100% da bateria. Além disso, temos mais de 1.500 pontos de recarga disponíveis em todo o Brasil. Utilizando um app ou mesmo o sistema multimídia de dentro do carro, você pode encontrar o mais próximo de você. Com a On Demand você pode até assinar um plano mensal para ter uma wallbox na sua casa.',
		},
		{
			id: 3,
			question: 'Preciso cancelar minha pré-reserva, o que devo fazer?',
			answer:
				'Esperamos que isso não seja necessário, pois existem muitas vantagens em ter Kwid E-tech por assinatura. Mas caso você tenha algum imprevisto e precise cancelar a sua pré-reserva, você deve entrar em contato conosco através dos nossos Canais de Atendimento (0800, Chat, Email ou WhatsApp) e formalizar a sua solicitação de cancelamento. A partir daí, o time Renault Renting irá iniciar os procedimentos para cancelamento da sua reserva e entrará em contato com você com os detalhes dos próximos passos  para a devolução do valor de reserva.',
		},
	],
	simulacao: {
		durationOptions: [
			{
				value: 12,
				text: 'meses',
			},
			{
				value: 24,
				text: 'meses',
			},
			{
				value: 36,
				text: 'meses',
			},
			{
				value: 48,
				text: 'meses',
			},
		],
		kmsOptions: [
			{
				value: 1000,
				text: 'km',
			},
			{
				value: 2000,
				text: 'km',
			},
		],
		colorOptions: [
			{
				value: 'Verde',
				text: 'Verde Noronha',
			},
			{
				value: 'Prata',
				text: 'Prata Diamond',
			},
			{
				value: 'Branco',
				text: 'Branco Polar',
			},
		],
	},
};

export const Home = {
	tuitionTo: 'Mensualidad desde',
	from: '',
	doSimulation: 'Hacer una simulación',
};

export const Header = {
	howDoesItWork: '¿Cómo funciona?',
	doubts: 'Preguntas frecuentes',
	forBusiness: 'Para negocios',
	ourStores: 'Nuestros Concesionarios',
	simulateNow: 'simular ahora',
	generateProposal: 'generar propuesta',
	contactUs: 'solicitar asesoria',
	consultantsArea: 'Area de consultoria',
	myProposals: 'Mis propuestas',
	clients: 'VER CLIENTES',
	generateAssistedSalesLink: 'generar link para venta asistida',
	generatePortLink: 'Generar link',
	my: 'Mi',
	cart: 'carrito',
	welcome: 'Bienvenido',
	access: 'Login',
	newRecord: 'Nuevo registro',
	sigin: 'Login',
	signup: 'Registro',
	signout: 'Salir',
	subscriptionCar: 'Vehículo en renting',
	fleetManagement: 'gestión de flotas',
	assistedSalesPortal: 'Portal de Venta Asistida',
	assistedSalesPortalKA: 'Portal de KA',
	assistedSalesPortalVE: 'Portal de Venta Especializada',
	consultantPortal: 'Portal del Consultor',
};

export const ApprovalModal = {
	approvalModalTitle: 'Criterios de aprobación',
	approvalModalText: 'Nuestro análisis de clientes contempla numerosas variables, con técnicas estadísticas que nos ayudan a definir si el producto es adecuado para cada cliente. Pero tranquilo, te ayudaremos explicándote los principales factores que afectan tus posibilidades de aprobación:',
	registerTitle: 'Registro',
	registerText: 'Debes ser mayor de 18 años. Con tu autorización, realizaremos un análisis en centrales de riesgo para conocer tu capacidad de pago.',
	creditProfileTitle: 'Perfil de evaluación del cliente',
	creditProfileText: 'Un buen puntaje crediticio aumenta tus posibilidades de ser aprobado, así que mantén el pago de tus obligaciones financieras al día.',
	monthlyIncomeTitle: 'Ingreso mensual',
	monthlyIncomeText: 'El pago mensual no debe comprometer un porcentaje muy alto de tus ingresos mensuales - recuerda que pueden suceder imprevistos.',
	downPaymentTitle: 'Pago inicial',
	downPaymentText: 'Además de obtener buenos descuentos, cuanto mayor sea tu pago inicial, mayores serán tus posibilidades de ser aprobado.',
};

export const DeliveryModal = {
	deliveryModalTitle: 'Entrega rápida',
	deliveryModalText: 'Aquí encontrarás los vehículos que tienen el menor tiempo de entrega, para que puedas disfrutar de él en pocos días.',
};

export const Location = {
	welcomeTo: 'Bienvenido al',
	assistedSalesPortal: 'Portal de Venta Asistida',
	assistedSalesPortalVE: 'Portal de Venta Especializada',
	physicalPerson: 'Persona natural',
	legalPerson: 'Persona jurídica',
	KAPerson: 'KA',
	changeLocation: 'Cambiar ubicación',
	seekingOut: 'Buscando',
	newSearch: 'nueva búsqueda',
};

export const Cars = {
	findYour: 'Encuentra tu',
	subscriptionCar: 'Vehículo en renting',
	orderBy: 'ordenar por',
	recommended: 'Recomendado',
	lowestPrice: 'Menor precio',
	biggestPrice: 'Mayor precio',
	fast: 'rápida',
	delivery: 'entrega',
	whatIsIncludedTitle: '¿Qué está incluido en el renting?',
	whatIsIncludedText: 'No hay costos ocultos, hemos preparado un servicio completo para ti:',
	whatIsIncludedStrongText: 'Vehículo 0Km | Seguros | Impuestos | Mantenimientos | Cuota mensual | Asistencia 24/7.',
	attention: 'Atención',
	attentionText: 'Este servicio ',
	attentionStrongText: 'no puede ser utilizado por conductores de plataformas de movilidad.',
	approvalCriteriaTitle: 'Criterios de aprobación',
	approvalCriteriaText: 'Debes ser mayor de 18 años. Con tu autorización, realizaremos un análisis en centrales de riesgo para conocer tu capacidad de pago.',
	approvalCriteriaMobileText: 'No aplica para conductores de plataformas de movilidad.',
	knowMore: 'Conoce más',
	iWantThisOne: 'Quiero este',
	monthlyFeesFrom: 'Pagos mensuales desde',
	approvalModal: ApprovalModal,
	deliveryModal: DeliveryModal,
};

export const Accessories = {
	accessories: 'Accesorios',
};

export const Settings = {
	selectVehicleColor: 'Selecciona el color del vehículo:',
	deliveryEstimate: 'Plazo estimado de entrega:',
	days: 'días',
	showAvailableColorsForFastDelivery: 'Mostrar colores disponibles para entrega rápida',
	subscriptionDuration: 'Duración del renting',
	monthlyMileage: 'Kilometraje mensual',
	firstMonthlyPayment: 'Primer Pago Mensual',
	youSave: 'Ahorraste',
	selectTheDealershipToPickUpYheVehicle: 'Selecciona el concesionario donde quieres que te entreguemos el vehículo',
	accessories: Accessories,
	financiaProtection: '¿Te gustaría tener mayor protección financiera?',
	insuranceDeductible: '¿Quieres agregar el seguro para evitar el pago de deducibles ante un siniestro?',
	yes: 'Sí',
	no: 'No',
	month: 'mes',
	iAmResponsible: 'Entiendo que soy responsable de cualquier retraso en los pagos mensuales',
	iUnderstand: 'Entiendo que soy responsable de pagar el deducible de la poliza de vehículo.',
	discountCode: '¿Tienes un código de descuento? Ingrésalo aquí.',
	licensePlate: 'Selecciona el último dígito de la placa del vehículo.',
	vehicleDescription: 'Descripción del vehículo',
	back: 'Volver',
	subscriptionSummary: 'resumen del renting',
	vehicle: 'Vehículo:',
	color: 'Color:',
	contractDuration: 'Duración del contrato:',
	excessMileage: 'Exceso de kilometraje:',
	receiveAtHomeBy: 'Recíbelo en casa por:',
	firstMonthDiscount: 'Descuento en la primera mensualidad:',
	discountCoupon: 'Cupón de descuento:',
	renewalDiscount: 'Descuento por renovación:',
	firstMonthlyFee: 'Primer pago mensual:',
	totalDiscount: 'Descuento total:',
	tuitionOf: 'Mensualidades de:',
	addToCart: 'Añadir al carrito',
	copyOfTheSimulation: '¿Te gustaría recibir una copia de la simulación?',
	receiveByEmail: 'Recibir por correo electrónico.',
	ourCreditAnalysis: 'Nuestro análisis de clientes contempla numerosas variables, con técnicas estadísticas que nos ayudan a definir si el producto es adecuado para cada cliente. Pero tranquilo, te ayudaremos explicándote los principales factores que afectan tus posibilidades de aprobación:',
	knowMore: 'Conoce más',
	simulationResult: 'resultado de la simulación',
	signature: 'Firmar',
	youSaved: 'Ahorraste',
	monthly: 'Kilometraje mensual',
	monthlyValue: 'mensualidades de:',
	youWillFind: 'Aquí encontrarás los vehículos que tienen el menor tiempo de entrega, para que puedas disfrutar de él en pocos días.',
	registerTitle: 'Registro',
	registerText: 'Debes ser mayor de 18 años. Con tu autorización, realizaremos un análisis en centrales de riesgo para conocer tu capacidad de pago.',
	creditProfileTitle: 'Perfil de evaluación del cliente',
	creditProfileText: 'Un buen puntaje crediticio aumenta tus posibilidades de ser aprobado, así que mantiene el pago de tus facturas al día.',
	monthlyIncomeTitle: 'Ingreso mensual',
	monthlyIncomeText: 'El pago mensual no debe comprometer un porcentaje muy alto de tus ingresos mensuales - recuerda que pueden suceder imprevistos.',
	downPaymentTitle: 'Pago inicial',
	downPaymentText: 'Además de obtener buenos descuentos, cuanto mayor sea tu pago inicial, mayores serán tus posibilidades de ser aprobado.',
	theFlexPlan: 'Selecciona el plazo en el cual quieres rentar tu vehículo y luego configura el kilometraje mensual que esperas recorrer.',
	numberOfMonthlyInstallments: 'Selecciona el número de mensualidades que quieres adelantar para obtener descuentos y reducir tu pago mensual',
	calculatedBasedOnSelected: '(Precio calculado con base a los artículos seleccionados hasta el momento.)',
	coverages: 'Coberturas:',
	findOutAboutOurInsurance: 'Conoce la poliza de vehículo',
	callCenter: 'Línea de atención',
};

export const Simulator = {
	profile: 'Perfil',
	physicalPerson: 'Persona física',
	legalPerson: 'Persona jurídica',
	placeOfDelivery: 'Lugar de entrega',
	lookFor: 'Buscar',
	useMyLocation: 'Usar mi ubicación',
	continue: 'Continuar',
	cars: Cars,
	settings: Settings,
};

export const Footer = {
	siteMap: 'Mapa del sitio',
	howDoesItWork: '¿Cómo funciona?',
	doubts: 'Preguntas frecuentes',
	forBusiness: 'Para negocios',
	runAsimulation: 'Hacer una simulación',
	solicitarAsesoria: 'Solicitar asesoria',
	serviceCenter: 'Línea de atención',
	hoursOfOperation: 'Horario de atención:',
	operationWeek: 'Lunes a Viernes 08:00 am a 05:00 pm',
	operationWeekend: 'Sábado 08:00 am a 12:00 pm',
	socialNetworks: 'Redes sociales',
	backToTheStart: 'Volver al inicio',
	termsOfUse: 'Términos de uso del sitio',
	termsOfCollection: 'Política de Cobranzas',
	cookiePolices: 'Políticas de cookies',
	privacyPolicy: 'Políticas de privacidad de protección de datos personales',
};

export const Basket = {
	mi: 'Mi ',
	cart: 'carrito',
	color: 'Color',
	quantity: 'Cantidad',
	contractDuration: 'Duración del contrato:',
	months: 'meses',
	monthlyMileage: 'Kilometraje mensual:',
	excessMileage: 'Exceso de kilometraje:',
	endOfLicensePlate: 'Terminación de placa:',
	receiveAtHomeBy: 'Recíbelo en casa por:',
	deliveryEstimate: 'Plazo estimado de entrega:',
	days: 'días',
	firstMonthlyFee: 'Primer pago mensual',
	tuitionOf: 'mensualidades de:',
	editProposal: 'Editar propuesta',
	excluding: 'Excluyendo...',
	deleteFromCart: 'Eliminar del carrito',
	attention: 'Atención:',
	maximumOfVehiclesKA: 'máximo 200 vehículos por NIT. Para una mayor cantidad',
	maximumOfVehiclesPJ: 'máximo 20 vehículos por NIT. Para una mayor cantidad',
	maximumOfVehiclesPF: 'máximo de 3 vehículos por documento',
	requestAQuote: 'solicitar cotización',
	addVehicle: 'Añadir vehículo',
	totalNumberOfVehicles: 'Número total de vehículos:',
	vehicles: 'vehículo(s)',
	firstMonthDiscount: 'Descuento en la primera mensualidad:',
	renewalDiscount: 'Descuento de renovación:',
	couponDiscount: 'Cupón de descuento:',
	youSaved: 'Ahorraste',
	firstMonthlyTotalFee: 'Pago total primera mensualidad :',
	tuition: 'Mensualidades',
	theSecondMonthly: '*EL segundo pago mensual se cobrará proporcionalmente a los días de cierre de la factura.',
	theInformedDelivery: '* El plazo de entrega informado se cuenta a partir de la fecha del pago de la primera mensualidad. Plazo sujeto a la disponibilidad del vehículo elegido hasta la fecha límite proporcionada en el contrato.',
	toSign: 'Firmar',
	toGoBack: 'Volver',
};

export const Login = {
	email: 'Correo electrónico',
	password: 'Contraseña',
	iForgotMyPassword: 'Olvide mi contraseña',
	loggingIn: 'Iniciando sesión..',
	physicalPerson: 'Persona natural',
	legalPerson: 'Persona jurídica',
	iWantToCreateAnAccount: 'Quiero crear una cuenta',
};

export const Register = {
	new: 'HAZ TU',
	register: 'registro',
	corporateName: 'Razón social',
	fullName: 'Nombre completo',
	fleetComposition: 'Composición de flota',
	email: 'Correo electrónico',
	NIT: 'NIT',
	confirmEmail: 'Confirmar correo electrónico',
	fromTheCompany: 'la empresa',
	confirm: 'Confirmar',
	confirmThe: 'Confirmar la',
	confirmYour: 'Confirmar tu correo electrónico',
	contactMe: 'Contactarme por',
	cellPhone: 'Celular',
	phone: 'Teléfono',
	state: 'Departamento',
	password: 'Contraseña',
	minimumCharacters: 'Mínimo 8 caracteres',
	aNumber: 'Un número',
	anUppercaseLetter: 'Una letra mayúscula',
	aSpecialCharacter: 'Un caracter especial',
	passwordConfirmation: 'Confirmación de contraseña',
	iAcceptAndAgree:
		'Al marcar esta casilla y continuar con el registro, aceptas los Términos de uso del sitio y la Política de tratamiento de datos. Durante el proceso de registro estaremos recolectando tus datos personales. El presente Aviso de Privacidad establece los términos y condiciones en virtud de los cuales Mobilize Lease&Co identificada con NIT 900.077.718–5 y con domicilio en Envigado, realizará dicho tratamiento. La finalidad de dicho tratamiento corresponde a todas aquellas previstas en nuestra política de tratamiento de datos personales la cual podrás encontrar en el siguiente enlace:',
	iAgreeToReceiveInformation: 'Acepto recibir información y promociones de Mobilize Lease&Co, de Mobilize Financial Services,  Renault Colombia y sus socios a través de correo electrónico, SMS o Whatsapp.',
	signingUp: 'registrando...',
	registerOne: 'Registrarme',
	theSearchedDocument: 'El documento buscado ya tiene un registro completo.',
	reviewRegistration: 'Revisar registro',
	registerClient: 'Registrar cliente',
	acceptPrivacyPolicy:
		'Al marcar esta casilla y continuar con el registro, aceptas los Términos de uso del sitio y la Política de tratamiento de datos. Durante el proceso de registro estaremos recolectando tus datos personales. El presente Aviso de Privacidad establece los términos y condiciones en virtud de los cuales Mobilize Lease&Co identificada con NIT 900.077.718–5 y con domicilio en Envigado, realizará dicho tratamiento. La finalidad de dicho tratamiento corresponde a todas aquellas previstas en nuestra política de tratamiento de datos personales la cual podrás encontrar en el siguiente enlace:',
	acceptPromotions: 'Acepto recibir información y promociones de Mobilize Lease&Co, de Mobilize Financial Services, Renault Colombia y sus socios a través de correo electrónico, SMS o Whatsapp.',
	continue: 'Continuar',
	createProposal: 'Crear Propuesta',
};

export const PhysicalPerson = {
	personalData: 'Datos personales',
	fullName: 'Nombres',
	enterAName: 'Ingresa un nombre.',
	surname: 'Apellidos',
	enterASurname: 'Ingresa un apellido.',
	nationality: 'Nacionalidad',
	enterANationality: 'Ingresa la nacionalidad.',
	dateOfBirth: 'Fecha de nacimiento',
	pleaseEnterAValidDate: 'Ingresa una fecha valida.',
	occupation: 'Ocupación',
	enterAnOccupation: 'Selecciona tu ocupación de trabajo',
	cellPhone: 'Celular',
	cellPhoneDdi: 'Prefijo',
	enterACellPhone: 'Ingresa un teléfono móvil.',
	email: 'Correo electrónico',
	emailConfirmation: 'Confirmar correo',
	pleaseProvideAValidEmail: 'Ingresa un correo electrónico válido.',
	address: 'Dirección',
	postalCode: 'Código postal',
	enterAZipCode: 'Ingresa un código postal.',
	street: 'Calle',
	enterAStreet: 'Ingresa una calle.',
	number: 'Número',
	enterANumber: 'Ingresa un numero.',
	complement: 'Complemento',
	neighborhood: 'Barrio',
	enterADistrict: 'Ingresa el barrio.',
	city: 'Ciudad',
	enterACity: 'Ingresa la ciudade.',
	state: 'Departamento',
	enterAState: 'Ingresa el departamento.',
	driversLicenseData: 'Datos de la licencia de conducción',
	dateOfFirstQualification: 'Fecha de expedición',
	driversLicense: 'Número de la licencia de conducción',
	validityOfDriversLicense: 'Vigencia de la licencia de conducción',
	category: 'Categoría',
	enterACategory: 'Ingresa una categoría.',
	updateDocuments: 'Actualizar documentos',
	changePassword: 'Cambiar contraseña',
	currentPassword: 'Contraseña actual',
	newPassword: 'Nueva contraseña',
	enterAPassword: 'Ingrese una contraseña.',
	confirmPassword: 'Confirmar contraseña',
	iAgreeToReceiveInformation: 'Acepto recibir información y promociones de Mobilize Lease&CO,',
	itsPartnersInMyEmail: ' de Mobilize Financial Services, Renault Colombiay sus socios através de correo eletrónico, SMS o Whatsapp.',
	updating: 'Actualizando...',
	updateData: 'Actualizar datos',
};

export const PersonalDataForm = {
	complete: 'Datos',
	register: 'Personales',
	toGoOut: 'Salir',
	dateOfBirth: 'Fecha de nacimiento',
	nationality: 'Nacionalidad',
	cellPhone: 'Celular',
	confirmationCodeContract: 'Se utilizará para enviar el código de confirmación al firmar el contrato.',
	selectYourOccupation: 'Selecciona tu ocupación',
	signingUp: 'registrando...',
	continue: 'Continuar',
};

export const AddressDataForm = {
	complete: 'completa tu',
	register: 'registro',
	zipCode: 'Código postal',
	iDoNotKnowMyPostalCode: 'No conozco mi código postal',
	address: 'Dirección',
	number: 'Número',
	complement: 'Complementar',
	neighborhood: 'Vecindario',
	city: 'Ciudad',
	state: 'Estado',
	toGoBack: 'Volver',
	signingUp: 'registrando...',
	continue: 'Continuar',
};

export const PartnersForm = {
	toGoBack: 'Volver',
	signingUp: 'registrando...',
	continue: 'Continuar',
};
export const ShareholdersForm = {
	toGoBack: 'Volver',
	signingUp: 'registrando...',
	continue: 'Continuar',
};
export const CompanyForm = {
	toGoBack: 'Volver',
	signingUp: 'registrando...',
	continue: 'Continuar',
	save: 'Guardar',
};

export const AdditionalFields = {
	toGoBack: 'Volver',
	signingUp: 'registrando...',
	continue: 'Continuar',
};

export const DocumentsDataForm = {
	complete: 'completa tu',
	register: 'registro',
	drivingLicenseNumber: 'Número de licencia de conducir',
	dateOofFirstQualification: 'Fecha de la 1ª calificación',
	driversLicense: 'Licencia de conducir',
	category: 'Categoría',
	toGoBack: 'Volver',
	sending: 'Enviando...',
	finalize: 'Finalizar',
};

export const UploadComponentString = {
	fileFormatOfUp: 'Documento en formato .jpeg, .png y .TIFF de hasta 10mb',
	fileFormatOfUpPJ: 'Documento en formato PDF, .jpeg, .jpg, .png hasta 10mb',
	removeTheDocumentPlasticAndMakeAllDataLegible: 'Retire el documento del plástico y asegúrese de que todos los datos sean legibles.',
	makeSureTheImageClearDoNotWearGlassesHatsAccessories: 'Asegúrate de que la imagen sea clara. No uses gafas, sombreros o accesorios',
	sending: 'Enviando...',
	toSend: 'Enviar',
	unsupportedFile: 'Documento no válido',
	checkTheSpecsAndSendAgain: 'verifica las especificaciones y envía de nuevo',
	removeDocumentPlasticAndMakeAllDataLegible: 'Retire el documento del plástico y asegúrese de que todos los datos sean legibles.',
	makeImageClearGlassesHatsAccessories: 'Asegúrate de que la imagen sea clara. No uses gafas, sombreros o accesorios',
	takeAPicture: 'Tomar la foto',
};

export const ProspectDataForm = {
	generateProspectTitle: 'Generar Prospecto',
	updating: 'Actualizando...',
	creating: 'Creando...',
	searching: 'Buscando...',
	continueRegister: 'Continuar Registro',
	continueProspect: 'Continuar Propuesta',
};

export const CustomProposalForm = {
	customizableProposalTitle: 'PROPUESTA A LA MEDIDA',
	updating: 'Actualizando...',
	addVehicle: 'Añadir vehículo',
	register: 'Cotizar',
	editing: 'Editar vehículo',
};

export const LegalPersonalDataForm = {
	companyData: 'Datos de la empresa',
	typeOfCompany: 'Tipo de empresa',
	enterATypeOfCompany: 'Selecciona un tipo de empresa.',
	corporateName: 'Razón social',
	enterACorporateReason: 'Ingresa la Razón Social.',
	companyCellPhone: 'Celular de la empresa',
	enterACellPhone: 'Ingresa un teléfono móvil.',
	companyLandlinePhone: 'Teléfono fijo de empresa',
	enterAPhoneNumber: 'Ingresa un número de teléfono.',
	companyEmailLogin: 'Correo eletrónico de la empresa - Login',
	pleaseProvideAValidEmail: 'Ingresa un correo electrónico válido.',
	companyEmailFinancialContact: 'Correo electrónico de la empresa - Contacto financiero',
	financialContactName: 'Nombre de contacto financiero',
	enterAName: 'Ingresa un nombre.',
	zipCode: 'Código postal',
	enterAZipCode: 'Ingresa un código postal.',
	street: 'Calle',
	entarAStreet: 'Ingresa una calle.',
	number: 'Número',
	enterANumber: 'Ingresa un numero.',
	complement: 'Complemento',
	neighborhood: 'Barrio',
	enterADistrict: 'Ingresa el barrio.',
	city: 'Ciudad',
	enterACity: 'Ingresa la ciudad',
	state: 'Departamento',
	enterAState: 'Introduzca el departamento.',
	partnerData: 'Datos del representante legal',
	membersFullName: 'Nombre completo del representate legal',
	cpf: 'Número de identificación',
	enterACPF: 'Ingresa un número.',
	nationality: 'Nacionalidad',
	enterANationality: 'Ingresa la nacionalidad',
	rne: 'RNE',
	dateOfBirth: 'Fecha de nacimiento',
	pleaseEnterAValidDate: 'Por favor ingresa una fecha valida.',
	occupation: 'Ocupación',
	enterAnOccupation: 'Selecciona tu ocupación.',
	membersEmail: 'Correo electrónico del representante legal',
	landline: 'Teléfono',
	cellPhone: 'Celular',
	cnhData: 'Datos de la licencia de conducción',
	drivingLicenseNumber: 'Número de la licencia de conducción',
	dateOfFirstQualification: 'Fecha de expedición',
	driversLicense: 'Vigencia de la licencia de conducción',
	category: 'Categoría',
	enterACategory: 'Ingresa una categoría',
	updateDocuments: 'Actualizar documentos',
	changePassword: 'Cambiar contraseña',
	currentPassword: 'Contraseña actual',
	newPassword: 'Nueva contraseña',
	enterAPassword: 'Ingresa una contraseña',
	confirmPassword: 'Confirmar contraseña',
	iAgreeToReceiveInformation: 'Acepto recibir información y promociones de Mobilize Lease&CO, ',
	andTtsPartnersInMyEmail: 'de Mobilize Financial Services, Renault Colombia y sus socios através de correo electrónico, SMS o Whatsapp.',
	updating: 'Actualizando...',
	updateData: 'Actualizar datos',
	signingUp: 'registrando...',
	save: 'Guardar',
};

export const ConfirmationCodeForm = {
	makeYour: 'Haz tu',
	register: 'registro',
	aConfirmationCodeHasBeenSentTo: 'Se ha enviado un código de confirmación a:',
	enterTheCodeReceivedInTheEmailBelow: 'Ingresa el código recibido en el correo electrónico:',
	sending: 'Enviando...',
	toSend: 'Enviar',
	reSend: 'Reenviar correo',
	ifYouDontReceiveTheEmailInYourInbox: 'Si no recibes el correo electrónico en tu bandeja de entrada, revisa tu bandeja de correos no deseados.',
	didNotGetTheEmail: '¿No recibiste el correo?',
	reSubmitting: 'Reenviando...',
	resendEmail: 'Reenviar correo',
	isTheRegisteredEmailIncorrect: '¿El correo electrónico registrado es incorrecto?',
	updateEmail: 'actualizar correo electrónico',
};

export const ConfirmedSuccessRegister = {
	registrationHasBeenConfirmed: 'Su registro ha sido confirmado con',
	success: 'éxito',
	doASimulationAndChoose: 'Haz una simulación y elige el vehículo que mejor se adapte a ti, con el plazo y kilometraje segun tus necesidades y conduce un vehículo 0 Km, por un pago mensual fijo.',
	simulateNow: 'Simular ahora',
};

export const ProfileTabOrdersString = {
	myRequests: 'Contratos Pendientes',
	finalizePendingContracts: 'Finaliza la gestión de tus contratos pendientes',
	attention: 'Atención:',
	theDeadlineForSigning: 'el plazo para la firma del contrato y el pago de la primera mensualidad es de 10 días calendario a partir de la fecha de envío de la propuesta por el cliente, después de ese tiempo, la solicitud será cancelada automáticamente.',
	lastOrders: 'Últimos contratos pendientes',
	orderBy: 'Ordenar por',
	olderOrders: 'Contratos pendientes más antiguos',
	mostRecentOrders: 'Contratos pendientes más recientes',
	emptyStateKA: 'No tienes un contrato con pendientes para formalizar. Visualiza tus contratos activos en la pestaña Mis Contratos.',
	emptyStatePNPJ: 'No tienes un contrato con pendientes para formalizar. Visualiza tus contratos activos en la pestaña Mis Contratos o encuentra ahora el vehículo que más se adapta a ti',
	simulateNow: 'Simular ahora',
	lookingForOrders: 'Buscando contratos pendientes...',
};

export const ProfileTabServices = {
	myServices: 'Mis Servicios',
	selectTheContract: 'Seleccione el contrato',
	contractNumber: 'Número de contrato:',
	lookingForDetails: 'Buscando detalles...',
	color: 'Color:',
	plate: 'Placa:',
	insuranceFranchise: 'Protección deducibles',
	financialPProtection: 'Protección financiera',
	services: 'Servicios',
	youDoNotHaveAnActiveOrder: 'No tienes un pedido activo. Visualiza tus contratos activos en la pestaña',
	myContractsOrFind: 'Mis Contratos o encuentra ahora el vehículo que más se adapta a ti',
	simulateNow: 'Simular ahora',
	lookingForServices: 'Buscando servicios..',
};

export const ProfileTabContract = {};

export const ProfileTabPaymentDetails = {};

export const NewPasswordComponentString = {
	registerANewOne: 'registrar una nueva',
	password: 'contraseña',
	newPassword: 'Nueva contraseña',
	minimumOfEightCharacters: 'Mínimo 8 caracteres',
	aNumber: 'Un número',
	anUppercaseLetter: 'Una letra mayúscula',
	aSpecialCharacter: 'un caracter especial',
	confirmYourPassword: 'Confirmar la contraseña',
	signingUp: 'Registrarme...',
	register: 'Guardar...',
};

export const ReviewYourSignature = {
	reviewYour: 'Revisa tu',
	signature: 'SOLICITUD DE RENTA',
	color: 'Color:',
	vehicles: 'Vehículo(s)',
	amount: 'Cantidad:',
	vehicleDescription: 'Descripción del vehículo',
	contractDuration: 'Duración del contrato:',
	months: 'meses',
	monthlyMileage: 'Kilometraje mensual:',
	excessMileage: 'Exceso de kilometraje:',
	endOfLicensePlate: 'Terminación de placa:',
	receiveAtHomeBy: 'Recíbelo en casa por:',
	deliveryEstimate: 'Plazo estimado de entrega:',
	firstMonthlyPayment: 'Pago total primera mensualidad:',
	tuitionOf: 'mensualidades de:',
	dealership: 'Concesionario',
	confirmSubscription: 'Confirmar firma',
	subscriptionSummary: 'Resumen del renting',
	totalNumberOfVehicles: 'Número total de vehículos:',
	vehicle: 'vehículo',
	renewalDiscount: 'Descuento de renovación:',
	firstMonthDiscount: 'Descuento en la primera mensualidad:',
	couponDiscount: 'Cupón de descuento:',
	youSaved: 'Ahorraste:',
	firstTotalMonthlyFee: 'Pago total primera mensualidad:',
	tuition: 'Mensualidades',
	client: 'Cliente:',
	document: 'Documento:',
	theSecondMonthlyFeeWill: '*EL segundo pago mensual se cobrará proporcionalmente a los días de cierre de la factura',
	confirming: 'Confirmando...',
	readFullConditions: 'leer condiciones completas',
	returnToCart: 'Volver al carrito',
	youWillShortlyReceive: 'En pocos minutos recibiras un correo electrónico con el estado de aprobación del pedido.',
	youWillShortlyReceiveDealer: 'En algunos minutos podrás ver el pedido en la sección "Mis propuestas" para hacerle seguimiento',
	trackOrder: 'VER ESTADO DEL PEDIDO',
	serviceIncluded: 'SERVICIOS INCLUIDOS',
	servicesIncludedInTheContract: 'SERVICIOS INCLUIDOS EN EL CONTRATO:',
	vehicleMaintenance: 'Mantenimiento de vehículo:',
	includedIn: 'Incluido en',
	maintenancePlanCoverage: 'Cobertura del plan de mantenimiento:',
	changeOfLubricantsChangeOfFilters:
		'Cobertura del plan de mantenimiento: Cambio de aceite, cambio de filtros (combustible, aire, aceite, aire acondicionado (en lasversiones que aplique), correas y líquidos), pastillas de freno, disco de freno, embrague, escape, bombillas, batería, amortiguadores y detiene amortiguadores, neumáticos (mínimo 20.000 km de recorrido).',
	autoInsurance: 'Seguro de vehículo:',
	partnerInsurer: 'Asegurador asociado:',
	propertyPersonalDamageCoverage: 'Poliza de responsabilidad civil:',
};

export const UserAreaNavigationBar = {
	myProfile: 'Mi perfil',
	myRequests: 'Contratos Pendientes',
	myContracts: 'Mis contratos',
	paymentData: 'datos de pago',
	myServices: 'Mis servicios',
};

export const ContractItemString = {};
